<template>
    <v-form-field v-bind="$props">
        <template v-slot:append>
            <slot name="append"></slot>
        </template>
        <template v-slot:label-prepend>
            <slot name="label-prepend"></slot>
        </template>
        <template v-slot:label-append>
            <slot name="label-append"></slot>
        </template>
        <template v-slot:label>
            <slot name="label"></slot>
        </template>
        <template v-slot:content>
            <v-switch
                    v-if="trueValue!=undefined&&falseValue!=undefined"
                    :true-value="trueValue"
                    :false-value="falseValue"
                    dense
                    hide-details
                    v-model="componentValue"
            ></v-switch>
            <v-switch
                    v-else
                    dense
                    hide-details
                    v-model="componentValue"
            ></v-switch>
        </template>
    </v-form-field>
</template>
<script>
    export default {
        name: "FormTextAreaField.vue",
        props: {
            small: {
                type: Boolean,
                default: false
            },
            xSmall: {
                type: Boolean,
                default: false
            },
            xxSmall: {
                type: Boolean,
                default: false
            },
            middle: {
                type: Boolean,
                default: false
            },
            large: {
                type: Boolean,
                default: false
            },
            xLarge: {
                type: Boolean,
                default: false
            },
            xxLarge: {
                type: Boolean,
                default: false
            },
            label: {
                type: String
            },
            disable: {
                type: Boolean,
                default: false,
            },
            readonly: {
                type: Boolean,
                default: false
            },
            text: {},
            value: {
            },
            placeholder: {type: String},
            autofocus: {
                type: Boolean,
                default: false
            },
            labelWidth: {
                type: Number
            },
            fieldWidth: {
                type: Number,
                default: 50
            },
            hideLabel: {
                type: Boolean,
                default: false
            },
            removeLabel: {
                type: Boolean,
                default: false
            },
            height: {
                type: Number,
                default: 80
            },
            trueValue: {},
            falseValue: {},
            vertical: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                componentValue: this.value
            }
        },
        computed: {
            disableEnable: {
                get() {
                    return this.disable;
                }
            }
        },
        watch: {
            value(val) {
                this.componentValue = val;
            },
            componentValue(val) {
                this.$emit('input', val);
            }
        },
        created() {
        },
        methods: {}
    }
</script>